import { toast } from "react-toastify";

export const errorResponse = (e) => {

  if (e?.response?.data?.message && typeof e?.response?.data?.message === "string")
    toast.error(e?.response?.data?.message);
  else
    if (e?.response?.data?.image && typeof e?.response?.data?.image[0] === "string")
      toast.error(e?.response?.data?.image[0]);
    else
      if (typeof e?.message === "string") toast.error(e?.message);
      else toast.error("Something Wrong! Please try again!");
};
